import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';

const ProjectCard = ({ project, index }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"]
    });

    // Parallax effect for image
    const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);
    const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.8, delay: index * 0.1 }}
            className={`group cursor-pointer ${index % 2 !== 0 ? 'md:mt-32' : ''}`}
        >
            <Link to={`/work/${project.id}`} className="block w-full h-full">
                <div className="relative aspect-[4/5] overflow-hidden rounded-sm mb-6 bg-[#111]">
                    <motion.div style={{ y, scale }} className="w-full h-full">
                        <img
                            src={project.image}
                            alt={project.title}
                            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                        />
                    </motion.div>
                    <div className="absolute top-4 left-4 text-[10px] font-bold border border-black/10 px-2 py-1 bg-white/80 backdrop-blur-sm rounded-full z-10">
                        {String(index + 1).padStart(2, '0')}
                    </div>
                </div>
                <div className="flex justify-between items-start border-t border-black/10 pt-4">
                    <div>
                        <span className="block text-xs uppercase tracking-widest opacity-50 mb-1">{project.client}</span>
                        <h3 className="font-migra text-3xl group-hover:italic transition-all duration-500">{project.title}</h3>
                    </div>
                    <div className="text-xs uppercase tracking-widest opacity-50">{project.category}</div>
                </div>
            </Link>
        </motion.div>
    );
};

export default ProjectCard;
